import { useShallow } from 'zustand/react/shallow';
import useGeneralSettingsStore from '../../../stores/GeneralSettings/useGeneralSettingsStore';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';

export const useBlockOrderWithoutCustomer = (isSuggested?: boolean) => {
  const { isSeller, isStore } = useApplicationContext();
  const { blockOrderWithoutCustomer } = useGeneralSettingsStore(
    useShallow((state) => ({
      blockOrderWithoutCustomer: state.generalSettings.blockOrderWithoutCustomer,
    })),
  );

  const shouldBlockWithoutCustomer =
    isStore || (!isSuggested && isSeller && blockOrderWithoutCustomer);

  return {
    shouldBlockWithoutCustomer,
  };
};
